<template>
   <v-container fluid class="grey lighten-4" style="min-height: calc(100vh - 64px)">
      <div style="height:90vh;" class="d-flex justify-center align-center" v-if="pageLoading">
         <v-progress-circular
            indeterminate
            color="primary"
         ></v-progress-circular>
      </div>
    
      <v-container fluid v-else>
         <v-row align="center" class="mb-4">
            <v-col
               class="d-flex mb-2"
               cols="12"
               sm="6"
               md="4"
            >
            <v-select
               v-model="manufacturer.type"
               :items="partyMasterType"
               key="val"
               item-text="text" 
               item-value="val" 
               label="Type"
               hide-details
               dense
               outlined
               
            ></v-select>
            </v-col>
         </v-row>

         <h4 class="mb-2">Details</h4>
         <validation-observer ref="observer" v-slot="{ invalid }">

            <form @submit.prevent="submit">

               <v-row>
                  <v-col cols="12" sm="6" md="4" class="">
                     <validation-provider v-slot="{ errors }" name="Name" rules="required">
                        <v-text-field v-model="manufacturer.name" :error-messages="errors" label="Name" dense outlined required></v-text-field>
                     </validation-provider>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" class="">
                     <validation-provider v-slot="{ errors }" name="Address" rules="required">
                        <v-text-field v-model="manufacturer.address" :error-messages="errors" label="Address" dense outlined required></v-text-field>
                     </validation-provider>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" class="" v-if="manufacturer.type === 'manufacturer'">
                     <validation-provider name="Facility">
                        <v-combobox
                           v-model="manufacturer.facility"
                           :items="facilityItems"
                           hide-selected
                           label="Facility"
                           @change="onChangeFacility"
                           multiple
                           item-text="name"
                           item-value="id"
                           outlined
                           dense
                           small-chips
                           deletable-chips>
                           <template v-slot:no-data>
                              <v-list-item>
                                 <v-list-item-content>
                                    <v-list-item-title>
                                       No results matching. Press <kbd>enter</kbd> to create a new one
                                    </v-list-item-title>
                                 </v-list-item-content>
                              </v-list-item>
                           </template>
                        </v-combobox>
                     </validation-provider>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" class="">
                     <validation-provider name="Country">
                        <v-select
                           v-model="manufacturer.country"
                           :items="countries"
                           label="Country"
                           dense
                           outlined
                           data-vv-name="Country">
                        </v-select>
                     </validation-provider>
                  </v-col>

                  <!-- <v-col cols="12" sm="6" md="4" class="">
                     <validation-provider name="State" >
                        <v-text-field v-model="manufacturer.state" label="State" dense outlined ></v-text-field>
                     </validation-provider>
                  </v-col> -->
                  <v-col cols="12" sm="6" md="4" class="">
                     <validation-provider name="State">
                        <v-combobox
                           v-model="manufacturer.state"
                           :items="stateItems"
                           hide-selected
                           label="State"
                           @change="onChangeState"
                           item-text="name"
                           item-value="name"
                           outlined
                           dense
                           small-chips
                           :return-object="false"
                           deletable-chips>
                           <template v-slot:no-data>
                           <v-list-item>
                              <v-list-item-content>
                                 <v-list-item-title>
                                 No results matching. Press <kbd>enter</kbd> to create a new one
                                 </v-list-item-title>
                              </v-list-item-content>
                           </v-list-item>
                           </template>
                        </v-combobox>
                     </validation-provider>
                  </v-col>

                  <!-- <v-col cols="12" sm="6" md="4" class="">
                     <validation-provider name="City" >
                        <v-text-field v-model="manufacturer.city" label="City" dense outlined ></v-text-field>
                     </validation-provider>
                  </v-col> -->
                  <v-col cols="12" sm="6" md="4" class="">
                     <validation-provider name="City">
                        <v-combobox
                           v-model="manufacturer.city"
                           :items="cityItems"
                           :return-object="false"
                           hide-selected
                           label="City"
                           
                           item-text="name"
                           item-value="name"
                           outlined
                           dense
                           small-chips
                           deletable-chips>
                           <template v-slot:no-data>
                           <v-list-item>
                              <v-list-item-content>
                                 <v-list-item-title>
                                 No results matching. Press <kbd>enter</kbd> to create a new one
                                 </v-list-item-title>
                              </v-list-item-content>
                           </v-list-item>
                           </template>
                        </v-combobox>
                     </validation-provider>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" class="" v-if="manufacturer.type === 'manufacturer'">
                     <validation-provider name="Pack Type">
                        <v-combobox
                           v-model="manufacturer.pack_type"
                           :items="packTypeItems"
                           hide-selected
                           label="Pack type"
                           @change="onChangePackType"
                           multiple
                           item-text="name"
                           item-value="id"
                           outlined
                           dense
                           small-chips
                           deletable-chips>
                           <template v-slot:no-data>
                           <v-list-item>
                              <v-list-item-content>
                                 <v-list-item-title>
                                 No results matching. Press <kbd>enter</kbd> to create a new one
                                 </v-list-item-title>
                              </v-list-item-content>
                           </v-list-item>
                           </template>
                        </v-combobox>
                     </validation-provider>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" class="" v-if="manufacturer.type === 'manufacturer'">
                     <validation-provider name="Dosage Form">
                        <v-combobox
                           v-model="manufacturer.dosage_form"
                           :items="dosageFormItems"
                           hide-selected
                           label="Dosage Form"
                           @change="onChangeDosageForm"
                           multiple
                           item-text="name"
                           item-value="id"
                           outlined
                           dense
                           small-chips
                           deletable-chips>
                           <template v-slot:no-data>
                           <v-list-item>
                              <v-list-item-content>
                                 <v-list-item-title>
                                 No results matching. Press <kbd>enter</kbd> to create a new one
                                 </v-list-item-title>
                              </v-list-item-content>
                           </v-list-item>
                           </template>
                        </v-combobox>
                     </validation-provider>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" class="" v-if="manufacturer.type === 'manufacturer'">
                     <validation-provider name="Category">
                        <v-combobox
                           v-model="manufacturer.category"
                           :items="categoryItems"
                           hide-selected
                           label="Category"
                           @change="onChangeCategory"
                           multiple
                           item-text="name"
                           item-value="id"
                           outlined
                           dense
                           small-chips
                           deletable-chips>
                           <template v-slot:no-data>
                           <v-list-item>
                              <v-list-item-content>
                                 <v-list-item-title>
                                 No results matching. Press <kbd>enter</kbd> to create a new one
                                 </v-list-item-title>
                              </v-list-item-content>
                           </v-list-item>
                           </template>
                        </v-combobox>
                     </validation-provider>
                  </v-col>

                  <v-col cols="12" sm="6" md="4" class="" v-if="manufacturer.type === 'manufacturer'">
                     <validation-provider name="Packing">
                        <v-combobox
                           v-model="manufacturer.packing"
                           :items="packingItems"
                           hide-selected
                           label="Packing"
                           @change="onChangePacking"
                           multiple
                           item-text="name"
                           item-value="id"
                           outlined
                           dense
                           small-chips
                           deletable-chips>
                           <template v-slot:no-data>
                              <v-list-item>
                                 <v-list-item-content>
                                    <v-list-item-title>
                                       No results matching. Press <kbd>enter</kbd> to create a new one
                                    </v-list-item-title>
                                 </v-list-item-content>
                              </v-list-item>
                           </template>
                        </v-combobox>
                     </validation-provider>
                  </v-col>

                  <!-- <v-col cols="12" sm="6" md="4" class="" v-if="manufacturer.type === 'manufacturer'">
                     <validation-provider name="Packing" >
                        <v-text-field v-model="manufacturer.packing" label="Packing"  dense outlined></v-text-field>
                     </validation-provider>
                  </v-col> -->

                  <v-col cols="12" sm="6" md="4" class="" v-if="manufacturer.type === 'manufacturer'">
                     <validation-provider name="Certificate">
                        <v-combobox
                           v-model="manufacturer.certificate"
                           :items="certificateItems"
                           hide-selected
                           label="Certificate"
                           @change="onChangeCertificate"
                           multiple
                           item-text="name"
                           item-value="id"
                           outlined
                           dense
                           small-chips
                           deletable-chips>
                           <template v-slot:no-data>
                              <v-list-item>
                                 <v-list-item-content>
                                    <v-list-item-title>
                                       No results matching. Press <kbd>enter</kbd> to create a new one
                                    </v-list-item-title>
                                 </v-list-item-content>
                              </v-list-item>
                           </template>
                        </v-combobox>
                     </validation-provider>
                  </v-col>

                  <!-- <v-col cols="12" sm="6" md="4" class="" v-if="manufacturer.type === 'manufacturer'">
                     <validation-provider name="Certificate" >
                        <v-text-field v-model="manufacturer.certificate" label="Certificate" dense outlined></v-text-field>
                     </validation-provider>
                  </v-col> -->

                  <v-col cols="12" sm="6" md="4" class="" v-if="manufacturer.type === 'wholesaler'">
                     <validation-provider name="Authorised">
                        <v-combobox
                           v-model="manufacturer.authorised"
                           :items="authorisedItems"
                           hide-selected
                           label="Authorised"
                           multiple
                           item-text="name"
                           @change="onChangeAuthorised"
                           item-value="id"
                           outlined
                           dense
                           small-chips
                           deletable-chips>
                           <template v-slot:no-data>
                           <v-list-item>
                              <v-list-item-content>
                                 <v-list-item-title>
                                 No results matching. Press <kbd>enter</kbd> to create a new one
                                 </v-list-item-title>
                              </v-list-item-content>
                           </v-list-item>
                           </template>
                        </v-combobox>
                     </validation-provider>
                  </v-col>

                  <v-col cols="12" class="" >
                     <validation-provider name="Note">
                        <v-textarea
                           label="Note"
                           auto-grow
                           outlined
                           rows="3"
                           row-height="25"
                           dense
                           v-model="manufacturer.note">
                        </v-textarea>
                     </validation-provider>
                  </v-col>

               </v-row>

               <div class="d-flex align-center justify-space-between mb-4">
                  <h4 class="mr-4">Contacts</h4>
                  <v-btn color="primary" @click="addManufacturerContact">Add</v-btn>
               </div>

               <v-row v-for="(field, i) in manufacturer.contacts" :key="i">
                  <v-col cols="11">
                     <v-row>
                        <v-col cols="12" sm="6" md="4" class="">
                           <validation-provider v-slot="{ errors }" name="Name" rules="required">
                              <v-text-field v-model="field.name" :error-messages="errors" label="Name" dense outlined required></v-text-field>
                           </validation-provider>
                        </v-col>

                        <v-col cols="12" sm="6" md="4" class="" >
                           <validation-provider v-slot="{ errors }" name="Email" 
                              :rules="{
                                 required: !field.phone || field.phone.length === 0,
                                 regex: /.+@.+\..+/
                              }" >
                              <v-text-field v-model="field.email" :error-messages="errors" label="E-mail" dense outlined></v-text-field>
                           </validation-provider>
                        </v-col>

                        <v-col cols="12" sm="6" md="4" class="">
                           <ValidationProvider v-slot="{ errors }" name="Phone" 
                              :rules="{
                                 required: !field.email || field.email.length === 0,
                                 regex: /^[\d ()+-]+$/
                              }">
                              <vue-tel-input-vuetify 
                                 v-model="field.phone"
                                 :error-messages="errors"
                                 label="Phone Number" 
                                 mode="international"
                                 dense 
                                 outlined>
                              </vue-tel-input-vuetify>
                           </ValidationProvider>
                           <!-- <validation-provider v-slot="{ errors }" name="field.phone" 
                              :rules="{
                                 required: !field.email || field.email.length === 0,
                                 regex: /^[\d ()+-]+$/
                              }">
                              <v-text-field 
                                 v-model="field.phone" 
                                 :error-messages="errors" 
                                 label="Phone Number" 
                                 dense 
                                 outlined 
                                 required>
                              </v-text-field>
                           </validation-provider> -->
                        </v-col>
                        
                        
                     </v-row>
                  </v-col>
                  <v-col cols="1" class="" >
                     <v-btn class="float-right" text color="primary" @click="removeManufacturerContact(i)"><v-icon>mdi mdi-delete</v-icon></v-btn>
                  </v-col>
               </v-row>
               
               <v-btn class="mt-6" color="primary" @click="createManufacturer" type="submit" :disabled="invalid || subBtn.loading" :loading="subBtn.loading">
                  submit
               </v-btn>
               
            </form>
         </validation-observer>


      </v-container>
   </v-container>
</template>

<script>
   import { required, email, regex } from 'vee-validate/dist/rules'
   import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'

   setInteractionMode('eager')

   extend('required', {
      ...required,
      message: 'This field is required',
   })

   extend('regex', {
      ...regex,
      message: '{_field_} is invalid',
   })

   extend('email', {
      ...email,
      message: 'Email must be valid',
   })

  export default {

    components: {
      ValidationProvider,
      ValidationObserver,
    },

    data: () => ({
      valid: true,
      partyMasterType: [
         { text: 'Manufacturer', val: 'manufacturer' },
         { text: 'Wholesaler', val: 'wholesaler' },
      ],

      subBtn: {
         loading:false,
      },
      
      
      countries: [ "Afghanistan", "Åland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas (the)", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia (Plurinational State of)", "Bonaire, Sint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory (the)", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Cayman Islands (the)", "Central African Republic (the)", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands (the)", "Colombia", "Comoros (the)", "Congo (the Democratic Republic of the)", "Congo (the)", "Cook Islands (the)", "Costa Rica", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czechia", "Côte d'Ivoire", "Denmark", "Djibouti", "Dominica", "Dominican Republic (the)", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Falkland Islands (the) [Malvinas]", "Faroe Islands (the)", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories (the)", "Gabon", "Gambia (the)", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Holy See (the)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea (the Democratic People's Republic of)", "Korea (the Republic of)", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic (the)", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands (the)", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia (Federated States of)", "Moldova (the Republic of)", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands (the)", "New Caledonia", "New Zealand", "Nicaragua", "Niger (the)", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands (the)", "Norway", "Oman", "Pakistan", "Palau", "Palestine, State of", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines (the)", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Republic of North Macedonia", "Romania", "Russian Federation (the)", "Rwanda", "Réunion", "Saint Barthélemy", "Saint Helena, Ascension and Tristan da Cunha", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin (French part)", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten (Dutch part)", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "Sudan (the)", "Suriname", "Svalbard and Jan Mayen", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan (Province of China)", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands (the)", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates (the)", "United Kingdom of Great Britain and Northern Ireland (the)", "United States Minor Outlying Islands (the)", "United States of America (the)", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela (Bolivarian Republic of)", "Viet Nam", "Virgin Islands (British)", "Virgin Islands (U.S.)", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe" ],
      pageLoading:false,
      packTypeSearch: null,
      stateItems: [],
      cityItems: [],
      packTypeItems: [],
      facilityItems: [],
      dosageFormItems: [],
      categoryItems: [],
      packingItems: [],
      certificateItems: [],
      authorisedItems: [],
      manufacturer: {
         type: 'manufacturer',
         name: '',
         address: '',
         facility: [],
         country: '',
         state: '',
         city: '',
         pack_type: [],
         dosage_form: [],
         category: [],
         packing: [],
         certificate: [],
         authorised: [],
         note: '',
         contacts: [
            {
               name: '',
               email: '',
               phone: null
            }
         ]
      },

    }),

    computed: {
      isRequired() {
         return this.manufacturer.name.length < 0
      }
    },
    
    mounted(){
      if(this.$route.meta.isUpdate){
            this.getPartyMasterDetails()
      }

      this.getFacility()
      this.getState()
      this.getCity()
      this.getPackType()
      this.getDosageForm()
      this.getCategory()
      this.getPacking()
      this.getCertificate()
      this.getAuthorised()
   },


    methods: {
      showName(){
         return this.manufacturer.name
      },

      createManufacturer(){
         // console.log(this.manufacturer.contacts.country);
         this.subBtn.loading = true;
         var requestObj = this.manufacturer
         
         var url = '';
         // const headers = {
         //    'Content-type' : 'application/json',
         //    'Accept': 'application/json'
         // }

         this.$refs.observer.validate()
         
         if(this.$route.meta.isUpdate){
            requestObj.id = this.$route.params.id
            url = "/api/update"                  
         }                    
         else
            url = "/api/insert"


         Vue.axios.post(url, requestObj)
            .then((res) => {
               // console.log(res);
               // this.submitLoading = true
               this.$store.commit('showSnackbar', {message: res.data.message})
               this.$router.push('/partyMaster');
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
               this.subBtn.loading = false;
            })
      },

      addManufacturerContact(){
         this.manufacturer.contacts.push({
            name: '',
            email: '',
            phone: null
         })
      },


      removeManufacturerContact(index) {
         this.manufacturer.contacts.splice(index, 1)
      },

      // removeWholesalerContact(index) {
      //    this.wholesaler.contacts.splice(index, 1)
      // },

      getFacility() {
         Vue.axios.post(`/api/search`, {
            modal : "Facility"
         })
         .then((res) => {
            const data = res.data.data
            this.facilityItems = data
         })
      },

      getPacking() {
         Vue.axios.post(`/api/search`, {
            modal : "Packing"
         })
         .then((res) => {
            const data = res.data.data
            this.packingItems = data
         })
      },

      getCertificate() {
         Vue.axios.post(`/api/search`, {
            modal : "Certificate"
         })
         .then((res) => {
            const data = res.data.data
            this.certificateItems = data
         })
      },

      getPackType() {
         Vue.axios.post(`/api/search`, {
            modal : "PackType"
         })
         .then((res) => {
            const data = res.data.data
            this.packTypeItems = data
         })
      },

      getState() {
         Vue.axios.post(`/api/search`, {
            modal : "State"
         })
         .then((res) => {
            const data = res.data.data
            this.stateItems = data
         })
      },

      getCity() {
         Vue.axios.post(`/api/search`, {
            modal : "City"
         })
         .then((res) => {
            const data = res.data.data
            this.cityItems = data
         })
      },

      getDosageForm() {
         Vue.axios.post(`/api/search`, {
            modal : "DosageForm"
         })
         .then((res) => {
            const data = res.data.data
            this.dosageFormItems = data
         })
      },

      getCategory() {
         Vue.axios.post(`/api/search`, {
            modal : "Category"
         })
         .then((res) => {
            const data = res.data.data
            this.categoryItems = data
         })
      },

      getAuthorised(){
         Vue.axios.post(`/api/search`, {
            modal : "Authorised"
         })
         .then((res) => {
            const data = res.data.data
            this.authorisedItems = data
         })
      },

      getPartyMasterDetails(){
         this.pageLoading = true
         Vue.axios.post(`/api/show`, {
            id: this.$route.params.id
         })
            .then((response) => {
               // console.log(response);

                  const data = response.data.data

                  this.manufacturer.type = data.type
                  this.manufacturer.name = data.name
                  this.manufacturer.address = data.address
                  this.manufacturer.facility = data.facility
                  this.manufacturer.country = data.country
                  this.manufacturer.state = data.state
                  if(data.state)
                     this.manufacturer.state = data.state.name
                  this.manufacturer.city = data.city
                  if(data.city)
                     this.manufacturer.city = data.city.name
                  this.manufacturer.pack_type = data.pack_type
                  this.manufacturer.dosage_form = data.dosage_form
                  this.manufacturer.category = data.category
                  this.manufacturer.packing = data.packing
                  this.manufacturer.certificate = data.certificate
                  this.manufacturer.authorised = data.authorised
                  this.manufacturer.note = data.note
                  this.manufacturer.contacts = data.contact
                                                                        
            })
            .catch((error) => {
               console.log(error)
            })
            .finally(() => {
               this.pageLoading = false
            })
      },

      onChangeFacility(entries) {
         for (let i=0;i<entries.length;i++){
            let entry = entries[i]
            if(typeof(entry) === 'string' && entry.trim()){
               const item = { name:entry}
               this.manufacturer.facility[i] = item;
              
            }
         }
         this.manufacturer.facility = this.manufacturer.facility;
      },

      onChangePacking(entries) {
         for (let i=0;i<entries.length;i++){
            let entry = entries[i]
            if(typeof(entry) === 'string' && entry.trim()){
               const item = { name:entry}
               this.manufacturer.packing[i] = item;
              
            }
         }
         this.manufacturer.packing = this.manufacturer.packing;
      },

      onChangeCertificate(entries) {
         for (let i=0;i<entries.length;i++){
            let entry = entries[i]
            if(typeof(entry) === 'string' && entry.trim()){
               const item = { name:entry}
               this.manufacturer.certificate[i] = item;
              
            }
         }
         this.manufacturer.certificate = this.manufacturer.certificate;
      },

      onChangeState(entries) {
         // for (let i=0;i<entries.length;i++){
         //    let entry = entries[i]
         //    if(typeof(entry) === 'string' && entry.trim()){
         //       const item = { name:entry}
         //       this.manufacturer.state[i] = item;
              
         //    }
         // }
         // this.manufacturer.state = this.manufacturer.state;
      },

      onChangeCity(entries) {
         // for (let i=0;i<entries.length;i++){
         //    let entry = entries[i]
         //    if(typeof(entry) === 'string' && entry.trim()){
         //       const item = { name:entry}
         //       this.manufacturer.city[i] = item;
              
         //    }
         // }
         // this.manufacturer.city = this.manufacturer.city;
      },

      onChangePackType(entries) {
         for (let i=0;i<entries.length;i++){
            let entry = entries[i]
            if(typeof(entry) === 'string' && entry.trim()){
               const item = { name:entry}
               this.manufacturer.pack_type[i] = item;
              
            }
         }
         this.manufacturer.pack_type = this.manufacturer.pack_type;
      },

      onChangeDosageForm(entries) {
         for (let i=0;i<entries.length;i++){
            let entry = entries[i]
            if(typeof(entry) === 'string' && entry.trim()){
               const item = { name:entry}
               this.manufacturer.dosage_form[i] = item;
              
            }
         }
         this.manufacturer.dosage_form = this.manufacturer.dosage_form;
      },

      onChangeCategory(entries) {
         for (let i=0;i<entries.length;i++){
            let entry = entries[i]
            if(typeof(entry) === 'string' && entry.trim()){
               const item = { name:entry}
               this.manufacturer.category[i] = item;
              
            }
         }
         this.manufacturer.category = this.manufacturer.category;
      },

      onChangeAuthorised(entries) {
         for (let i=0;i<entries.length;i++){
            let entry = entries[i]
            if(typeof(entry) === 'string' && entry.trim()){
               const item = { name:entry}
               this.manufacturer.authorised[i] = item;
              
            }
         }
         this.manufacturer.authorised = this.manufacturer.authorised;
      },
    }
  }
</script>

<style>

</style>